export const GET_TRACKED_ITEMS_PER_SITE_SUCCESS = "GET_TRACKED_ITEMS_PER_SITE_SUCCESS";
export const CLEAR_TRACKED_ITEMS_PER_SITE_SUCCESS = "CLEAR_TRACKED_ITEMS_PER_SITE_SUCCESS";
